<div class="news-container">
    @if(!showAll){
    <p class="widget-title">{{(pageContent | contentFilter: LABELS.NEWS_WIDGET_LABEL) || 'News & Announcements'}}</p>
    }
    <div class="news-list">
        <mat-card>
            @if((showAll ? pagedNewsList.length : newsList.length) > 0){
            @for(item of showAll ? pagedNewsList : newsList; track item){
            <div class="news-item" 
                [attr.data-aue-resource]="getAueResourceForItem(item)"                data-aue-type="component"
                data-aue-model="lpmi/components/common/article" 
                data-aue-label="Article" >
                <div class="image-container"
                    (click)="redirectToArticle(item)"
                    (keydown)="onKeyDown($event)">
                    @if(item?.mediaType === 'video'){
                        <img [src]="item?.thumbnailImage" alt="Image"
                          data-aue-prop="thumbnailImage"
                          data-aue-type="media"
                          data-aue-filter="dam">
                    }
                    @else{
                         <img [src]="item?.mobileImage" alt="Image"
                          data-aue-prop="mobileImage"
                          data-aue-type="media"
                          data-aue-filter="dam">
                    }
                </div>
                <div class="news-info news-info-content">
                    <div class="title" (click)="redirectToArticle(item)"
                      data-aue-prop="title"
                      data-aue-type="text"
                      (keydown)="onKeyDown($event)">{{ item.title }}</div>
                    <div class="desc" [innerHTML]="getSanitizedText(item.description || '')"
                      data-aue-prop="description"
                      data-aue-type="richtext"></div>
                    <input type="hidden"
                      data-aue-prop="mediaType"
                      data-aue-type="select"
                      [value]="item?.mediaType">
                </div>
            </div>
            }
            @empty {
            <p class="error-message">{{ (pageContent | contentFilter: LABELS.ERROR_MSG) || 'Could not load the widget'
                }}</p>
            }
            @if(!showAll){
            <nuc-link-button class="view-button"
                text="{{(pageContent | contentFilter: LABELS.VIEW_ALL) || 'View All News'}}"
                styleClass="primaryBtn mobilefont" (click)="onClick()"></nuc-link-button>
            }
            }
        </mat-card>

        @if(showAll && newsList.length > 5){
        <mat-paginator [length]="newsList.length" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"
            (page)="onPageChange($event)">
        </mat-paginator>
        }
    </div>

</div>